// Ported verbatim from qr-api's src/modules/utils/currency-symbols-map.ts —
// per Payments team (Daniel, Slack 2026-08-11): CLDR price formatting is
// expected to be done frontend-side, not by PMS.
export const currencySymbolsMap: Record<string, string> = {
	AED: 'AED',
	AFN: '؋',
	ALL: 'ALL',
	AMD: '֏',
	ANG: 'ANG',
	AOA: 'Kz',
	ARS: 'ARS',
	AUD: 'A$',
	AWG: 'AWG',
	AZN: '₼',
	BAM: 'KM',
	BBD: '$',
	BDT: '৳',
	BGN: 'BGN',
	BHD: 'BHD',
	BIF: 'BIF',
	BMD: '$',
	BND: 'BND',
	BOB: 'Bs',
	BOV: 'BOV',
	BRL: 'R$',
	BSD: '$',
	BTC: '₿',
	BTN: 'BTN',
	BWP: 'P',
	BYN: 'BYN',
	BYR: 'BYR',
	BZD: '$',
	CAD: 'CA$',
	CDF: 'CDF',
	CHE: 'CHE',
	CHF: 'CHF',
	CHW: 'CHW',
	CLF: 'CLF',
	CLP: 'CLP',
	CNH: 'CN¥',
	CNY: 'CN¥',
	COP: 'COP',
	COU: 'COU',
	CRC: '₡',
	CUC: '$',
	CUP: '$',
	CVE: 'CVE',
	CZK: 'Kč',
	DJF: 'DJF',
	DKK: 'DKK',
	DOP: '$',
	DZD: 'DZD',
	EEK: 'EEK',
	EGP: 'E£',
	ERN: 'ERN',
	ETB: 'ETB',
	ETH: 'Ξ',
	EUR: '€',
	FJD: '$',
	FKP: '£',
	GBP: '£',
	GEL: '₾',
	GGP: '£',
	GHC: '₵',
	GHS: 'GH₵',
	GIP: '£',
	GMD: 'GMD',
	GNF: 'FG',
	GTQ: 'Q',
	GYD: '$',
	HKD: 'HK$',
	HNL: 'L',
	HRK: 'kn',
	HTG: 'HTG',
	HUF: 'Ft',
	IDR: 'Rp',
	ILS: '₪',
	IMP: '£',
	INR: '₹',
	IQD: 'IQD',
	IRR: 'IRR',
	ISK: 'ISK',
	JEP: '£',
	JMD: '$',
	JOD: 'JOD',
	JPY: '¥',
	KES: 'KES',
	KGS: '⃀',
	KHR: '៛',
	KMF: 'CF',
	KPW: '₩',
	KRW: '₩',
	KWD: 'KWD',
	KYD: '$',
	KZT: '₸',
	LAK: '₭',
	LBP: 'L£',
	LKR: 'LKR',
	LRD: '$',
	LSL: 'LSL',
	LTC: 'Ł',
	LTL: 'LTL',
	LVL: 'LVL',
	LYD: 'LYD',
	MAD: 'MAD',
	MDL: 'MDL',
	MGA: 'Ar',
	MKD: 'MKD',
	MMK: 'K',
	MNT: '₮',
	MOP: 'MOP',
	MRO: 'MRO',
	MRU: 'MRU',
	MUR: 'MUR',
	MVR: 'MVR',
	MWK: 'MWK',
	MXN: 'MX$',
	MXV: 'MXV',
	MYR: 'RM',
	MZN: 'MZN',
	NAD: '$',
	NGN: '₦',
	NIO: 'C$',
	NOK: 'NOK',
	NPR: 'NPR',
	NZD: 'NZ$',
	OMR: 'OMR',
	PAB: 'PAB',
	PEN: 'PEN',
	PGK: 'PGK',
	PHP: '₱',
	PKR: 'Rs',
	PLN: 'zł',
	PYG: '₲',
	QAR: 'QAR',
	RMB: '￥',
	RON: 'lei',
	RSD: 'RSD',
	RUB: '₽',
	RWF: 'RF',
	SAR: 'SAR',
	SBD: '$',
	SCR: 'SCR',
	SDG: 'SDG',
	SEK: 'kr',
	SGD: 'SGD',
	SHP: '£',
	SLL: 'SLL',
	SOS: 'SOS',
	SRD: '$',
	SSP: '£',
	STD: 'STD',
	STN: 'Db',
	SVC: 'SVC',
	SYP: '£',
	SZL: 'SZL',
	THB: '฿',
	TJS: 'TJS',
	TMT: 'TMT',
	TND: 'TND',
	TOP: 'T$',
	TRL: '₤',
	TRY: '₺',
	TTD: 'TTD',
	TVD: '$',
	TWD: 'NT$',
	TZS: 'TZS',
	UAH: '₴',
	UGX: 'UGX',
	USD: '$',
	UYI: 'UYI',
	UYU: '$',
	UYW: 'UYW',
	UZS: 'UZS',
	VEF: 'Bs',
	VES: 'VES',
	VND: '₫',
	VUV: 'VUV',
	WST: 'WST',
	XAF: 'FCFA',
	XBT: 'Ƀ',
	XCD: '$',
	XOF: 'F CFA',
	XPF: 'CFPF',
	XSU: 'Sucre',
	XUA: 'XUA',
	YER: 'YER',
	ZAR: 'R',
	ZMW: 'ZK',
	ZWD: 'ZWD',
	ZWL: 'ZWL',
}

// Currencies where Intl's `narrowSymbol` display is ambiguous (e.g. just
// "$" for CAD/AUD/NZD, indistinguishable from USD) — use the full `symbol`
// display for these instead.
export const ambiguousNarrowSymbolCurrencies = new Set([
	'ARS',
	'AUD',
	'BND',
	'CAD',
	'CLP',
	'COP',
	'HKD',
	'MXN',
	'NZD',
	'SGD',
	'TTD',
	'TWD',
	'CNY',
	'DKK',
	'ISK',
	'NOK',
	'LKR',
	'MUR',
	'NPR',
])
